// Override Settings
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
var bcSfFilterSettings = {
  general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
  },
};

var isSearch = $('.template-search').length;

var svgHeart =
  '<div class="product-item__loader"><img src="https://cdn.shopify.com/s/files/1/1991/8975/files/loader.gif?v=1576659094" alt="Heart" /></div><!-- /.product-item__loader -->';

// Declare Templates
var bcSfFilterTemplate = {
  soldOutClass: 'sold-out',
  saleClass: 'on-sale',
  soldOutLabelHtml: '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
  saleLabelHtml: '<div>' + bcSfFilterConfig.label.sale + '</div>',
  vendorHtml: '<div>{{itemVendorLabel}}</div>',

  // Grid Template
  productGridItemHtml:
    '<div class="product-item js-product-item" data-product-id="{{itemId}}">' +
    '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script><form method="post" action="/cart/add" accept-charset="UTF-8" class="form-product-small js-form-product-small" enctype="multipart/form-data"><input type="hidden" name="form_type" value="product" tabindex="0" class=""><input type="hidden" name="utf8" value="✓" tabindex="0" class=""><input type="hidden" id="product-item-pre_order-{{itemId}}" name="" value="" data-prop-name="properties[PreOrder]" data-prop-prefix="This pre-ordered item will ship:" data-prop-date="">{{itemOnSaleAttribute}}' +
    '<input type="hidden" name="quantity" value="1"><div class="product-item__select hidden">{{itemSelect}}</div>' +
    '<div class="product-item__inner">' +
    '<div class="product-item__images">' +
    '{{itemWishlist}}' +
    svgHeart +
    '<div class="product-item__image">' +
      '{{variantImagesHtml}}' +
    '</div>' +
    '<div class="product__item__banner__tag">{{itemTag}}</div>' +
    '<div class="product-item__bar">' +
      '{{variantsSizeHtml}}' +
    '</div>' +
    '</div>' +
    '<div class="product-item__content">' +
    '<div class="product-item__line">' +
    '<h4 class="title-primary product-item__title">' +
      '<a href="{{itemUrl}}">{{itemTitle}}</a>' +
    '</h4>' +
    '<div class="product-item__price-holder">' +
      '<span class="product-item__price js-product-item-price">{{itemPrice}}</span>' +
      // '<span class="product-item__price-text">{{itemPriceTagText}}</span>' +
    '</div>' +
    '{{variantsHtml}}' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</form>' +
    '</div>',

  // Pagination Template
  previousActiveHtml: '<li class="pagination-link pagination-prev"><a href="{{itemUrl}}"><span class="acc">&lt;</span></a></li>',
  previousDisabledHtml: '<li class="disabled disabled-icon pagination-link pagination-prev"><span class="acc">&lt;</span></li>',
  nextActiveHtml: '<li class="pagination-link pagination-next"><a href="{{itemUrl}}"><span class="acc">&gt;</span></a></li>',
  nextDisabledHtml: '<li class="disabled disabled-icon pagination-link pagination-next"><span class="acc">&gt;</span></li>',
  pageItemHtml: '<li class="pagination-link"><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml: '<li class="pagination-link pagination-active"><span class="active">{{itemTitle}}</span></li>',
  pageItemRemainHtml: '<li><span>{{itemTitle}}</span></li>',
  paginateHtml: '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

  // Sorting Template
  sortingHtml: '<label class="label--hidden h3">Sort By: </label><select class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

/**
 * Build collection marketing blocks - START
 */
var marketingBlocks = [];
if (!isSearch) {
  var hasVerticalBlock = false;
  var collectionMarketingBlocks = Shopify.collection.metafields.marketing_blocks;
  var marketingBlocksCount = collectionMarketingBlocks.style ? collectionMarketingBlocks.style.length : 0;

  for (var i = 0; i < marketingBlocksCount; i++) {
    // Anchor Link
    let marketingBlockAnchor = '';
    // hyper link target boolean
    let targetString;
    let targetExists;
    if (Shopify.collection.metafields.marketing_blocks.new_window !== undefined) { targetExists = Shopify.collection.metafields.marketing_blocks.new_window[i]; }
    if (targetExists) { targetString = "_blank" } else { targetString = "_self" }
    let newTarget = `target="${targetString}"`

    if (collectionMarketingBlocks.url_anchor[i].length) {
      marketingBlockAnchor = 'id="' + collectionMarketingBlocks.url_anchor[i] + '" ';
    }

    let marketingBlockImageHtml = '<div ' + marketingBlockAnchor + 'class="product-items__banner">';
    let marketingBlockImageContentHtml = '<div ' + marketingBlockAnchor + 'class="product-items__banner-image-content">';
    // Image/video
    if (
      collectionMarketingBlocks.style != null &&
      (collectionMarketingBlocks.style[i] == 'Image fullwidth' || collectionMarketingBlocks.style[i] == 'Image vertical')
    ) {
      if (collectionMarketingBlocks.style[i] == 'Image vertical') {
        marketingBlockImageHtml = marketingBlockImageHtml.replace(
          'class="product-items__banner',
          'class="product-items__banner product-items__banner--vertical'
        );

        if (collectionMarketingBlocks.left_align_vertical_banner != null && collectionMarketingBlocks.left_align_vertical_banner[i] == 'true') {
          marketingBlockImageHtml = marketingBlockImageHtml.replace(
            'product-items__banner--vertical',
            'product-items__banner--vertical product-items__banner--vertical-left'
          );
        }
      }

      if (collectionMarketingBlocks.image != null && collectionMarketingBlocks.image[i] != '') {
        marketingBlockImageHtml += `<img src="${collectionMarketingBlocks.image[i]}" />`;

        if (collectionMarketingBlocks.image__mobile != null && collectionMarketingBlocks.image__mobile[i] != '') {
          marketingBlockImageHtml = marketingBlockImageHtml.replace('<img', '<img class="hidden-xs"');
          marketingBlockImageHtml += `<img class="visible-xs-block" src="${collectionMarketingBlocks.image__mobile[i]}" />`;

          if (collectionMarketingBlocks.style[i] == 'Image vertical') {
            marketingBlockImageHtml = marketingBlockImageHtml
              .replace('img', 'div')
              .replace(`src="${collectionMarketingBlocks.image__mobile[i]}"`, `style="background-image: url(${collectionMarketingBlocks.image__mobile[i]});"`);
          }
        }

        if (collectionMarketingBlocks.style[i] == 'Image vertical') {
          marketingBlockImageHtml = marketingBlockImageHtml
            .replace('img', 'div')
            .replace(`src="${collectionMarketingBlocks.image[i]}"`, `style="background-image: url(${collectionMarketingBlocks.image[i]});"`);
        }

        marketingBlockImageHtml += '</div>';
      }

      if (collectionMarketingBlocks.video != null && collectionMarketingBlocks.video[i] != '') {
        marketingBlockImageHtml += `<iframe src="${collectionMarketingBlocks.video[i]}?loop=1&autoplay=1&background=0&controls=0&muted=1&playsinline=1&title=0" frameborder="0"></iframe>`;
        marketingBlockImageHtml = marketingBlockImageHtml.replace('class="product-items__banner', 'class="product-items__banner product-items__banner--video');

        if (collectionMarketingBlocks.video__mobile != null && collectionMarketingBlocks.video__mobile[i] != '') {
          marketingBlockImageHtml = marketingBlockImageHtml.replace('<iframe', '<iframe class="hidden-xs"');

          marketingBlockImageHtml += `<iframe class="visible-xs-block" src="${collectionMarketingBlocks.video__mobile[i]}?loop=1&autoplay=1&background=0&controls=0&muted=1&playsinline=1&title=0" frameborder="0"></iframe>`;
        }
        marketingBlockImageHtml += '</div>';
      }

      if (
        collectionMarketingBlocks.show_on_mobile == null ||
        (collectionMarketingBlocks.show_on_mobile != null && collectionMarketingBlocks.show_on_mobile[i] != 'true')
      ) {
        marketingBlockImageHtml = marketingBlockImageHtml.replace('class="', 'class="hidden-xs ');
      }

      if (
        collectionMarketingBlocks.style[i] == 'Image fullwidth' &&
        collectionMarketingBlocks.hyper_link != null &&
        collectionMarketingBlocks.hyper_link[i] != ''
      ) {
        marketingBlockImageHtml = marketingBlockImageHtml.replace(
          '</div>',
          '<a class="product-items__banner-link" ' + newTarget + ' href="' + collectionMarketingBlocks.hyper_link[i] + '"></a></div>'
        );
      }

      if (
        collectionMarketingBlocks.style[i] == 'Image vertical' &&
        collectionMarketingBlocks.hyper_link != null &&
        collectionMarketingBlocks.hyper_link[i] != ''
      ) {
        marketingBlockImageHtml = marketingBlockImageHtml.replace(
          '<div class="product-items__banner product-items__banner--vertical">',
          '<div class="product-items__banner product-items__banner--vertical"><a class="product-items__banner-link" ' + newTarget + ' href="' +
          collectionMarketingBlocks.hyper_link[i] +
          '"></a>'
        );
        marketingBlockImageHtml = marketingBlockImageHtml.replace(
          '<div class="product-items__banner product-items__banner--vertical product-items__banner--vertical-left">',
          '<div class="product-items__banner product-items__banner--vertical product-items__banner--vertical-left"><a ' + newTarget + 'class="product-items__banner-link" href="' +
          collectionMarketingBlocks.hyper_link[i] +
          '"></a>'
        );
      }

      if (marketingBlockImageHtml != '<div class="product-items__banner">' || '<div class="product-items__banner product-items__banner--vertical">') {
        marketingBlocks.push({
          position: parseInt(collectionMarketingBlocks.order[i]),
          html: marketingBlockImageHtml,
        });
      }
    }

    // Image/content
    if (
      (collectionMarketingBlocks.style != null && collectionMarketingBlocks.style[i] == 'Image with text') ||
      (collectionMarketingBlocks.style != null && collectionMarketingBlocks.style[i] == 'Image with text fullwidth') ||
      (collectionMarketingBlocks.style != null && collectionMarketingBlocks.style[i] == 'Text')
    ) {
      let mobileCenterClass = '';

      if (! (collectionMarketingBlocks.image != null && collectionMarketingBlocks.image[i] != '')) {
        mobileCenterClass = 'product-items__banner-image-content--content-mobile-center';
      }

      if (collectionMarketingBlocks.style[i] == 'Image with text fullwidth') {
        marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace(
          'product-items__banner-image-content',
          'product-items__banner-image-content product-items__banner-image-content--fullwidth'
        );
      } else if (collectionMarketingBlocks.style[i] == 'Text') {
        if (collectionMarketingBlocks.block_with_content_only_layout != null && collectionMarketingBlocks.block_with_content_only_layout[i] == 'Left') {
          marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace(
            'product-items__banner-image-content',
            `product-items__banner-image-content product-items__banner-image-content--content-only-left ${mobileCenterClass}`
          );
        } else if (
          collectionMarketingBlocks.block_with_content_only_layout != null &&
          collectionMarketingBlocks.block_with_content_only_layout[i] == 'Center'
        ) {
          marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace(
            'product-items__banner-image-content',
            `product-items__banner-image-content product-items__banner-image-content--content-only-center ${mobileCenterClass}`
          );
        } else if (collectionMarketingBlocks.block_with_content_only_layout != null && collectionMarketingBlocks.block_with_content_only_layout[i] == 'Right') {
          marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace(
            'product-items__banner-image-content',
            `product-items__banner-image-content product-items__banner-image-content--content-only-right ${mobileCenterClass}`
          );
        }
      }

      if (collectionMarketingBlocks.image != null && collectionMarketingBlocks.image[i] != '') {
        marketingBlockImageContentHtml += `
            <div class="product-items__banner-image-content__image">
              <div style="background-image: url(${collectionMarketingBlocks.image[i]});"></div>
            </div>`;
        if (collectionMarketingBlocks.image__mobile != null && collectionMarketingBlocks.image__mobile[i] != '') {
          marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace(
            'product-items__banner-image-content__image',
            'product-items__banner-image-content__image hidden-xs'
          );
          marketingBlockImageContentHtml += `<div class="product-items__banner-image-content__image visible-xs-block">
              <div style="background-image: url(${collectionMarketingBlocks.image__mobile[i]});"></div>
            </div>`;
        }

        if (collectionMarketingBlocks.hyper_link != null && collectionMarketingBlocks.hyper_link[i] != '') {
          marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace(
            '<div class="product-items__banner-image-content__image',
            '<a class="product-items__banner-link" ' + newTarget + ' href="' +
            collectionMarketingBlocks.hyper_link[i] +
            '"></a><div class="product-items__banner-image-content__image'
          );
        }
      }

      if (collectionMarketingBlocks.video != null && collectionMarketingBlocks.video[i] != '') {
        marketingBlockImageContentHtml += `
            <div class="product-items__banner-image-content__video">
              <iframe src="${collectionMarketingBlocks.video[i]}?loop=1&autoplay=1&background=0&controls=0&muted=1&playsinline=1&title=0" frameborder="0"></iframe>
            </div>`;
        if (collectionMarketingBlocks.video__mobile != null && collectionMarketingBlocks.video__mobile[i] != '') {
          marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace(
            'product-items__banner-image-content__video',
            'product-items__banner-image-content__video hidden-xs'
          );
          marketingBlockImageContentHtml += `<div class="product-items__banner-image-content__video visible-xs-block">
              <iframe src="${collectionMarketingBlocks.video__mobile[i]}?loop=1&autoplay=1&background=0&controls=0&muted=1&playsinline=1&title=0" frameborder="0"></iframe>
            </div>`;
        }
      }

      if ((collectionMarketingBlocks.title != null && collectionMarketingBlocks.title[i] != '') || (collectionMarketingBlocks.text != null && collectionMarketingBlocks.text[i] != '')) {
        if ((collectionMarketingBlocks.title_bold_color != null && collectionMarketingBlocks.title_bold_color[i] != '') || (collectionMarketingBlocks.mobile_title_bold_color != null && collectionMarketingBlocks.mobile_title_bold_color[i] != '')) {
          let desktopTitleBoldColor = '';
          let mobileTitleBoldColor = '';

          if (collectionMarketingBlocks.title_bold_color != null && collectionMarketingBlocks.title_bold_color[i] != '') {
            desktopTitleBoldColor = `
              #product-item-content-${i} .product-items__banner-image-content__title p strong:after {
                background-color: ${collectionMarketingBlocks.title_bold_color[i]}
              }
            `;
          }

          if (collectionMarketingBlocks.mobile_title_bold_color != null && collectionMarketingBlocks.mobile_title_bold_color[i] != '') {
            mobileTitleBoldColor = `
              @media (max-width: 767px) {
                #product-item-content-${i} .product-items__banner-image-content__title p strong:after {
                  background-color: ${collectionMarketingBlocks.mobile_title_bold_color[i]}
                }
              }
            `;
          }

          marketingBlockImageContentHtml += `
            <style type="text/css" media="screen">
              ${desktopTitleBoldColor}
              ${mobileTitleBoldColor}
            </style>`;
        }

        marketingBlockImageContentHtml += `<div id="product-item-content-${i}" class="product-items__banner-image-content__content">`;

        if (collectionMarketingBlocks.title != null && collectionMarketingBlocks.title[i] != '') {
          marketingBlockImageContentHtml += `
              <div class="product-items__banner-image-content__title">
                ${collectionMarketingBlocks.title[i].html}
              </div>`;
          if (collectionMarketingBlocks.title_mobile != null && collectionMarketingBlocks.title_mobile[i] != '') {
            marketingBlockImageContentHtml += `
              <div class="visible-xs-block product-items__banner-image-content__title">
                ${collectionMarketingBlocks.title_mobile[i].html}
              </div>`;
            marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace(
              '<div class="product-items__banner-image-content__title"',
              '<div class="hidden-xs product-items__banner-image-content__title"'
            );
          }
        }

        if (collectionMarketingBlocks.text != null && collectionMarketingBlocks.text[i] != '') {
          marketingBlockImageContentHtml += `
              <div class="product-items__banner-image-content__entry">
                ${collectionMarketingBlocks.text[i]}
              </div>`;
          if (collectionMarketingBlocks.text_mobile != null && collectionMarketingBlocks.text_mobile[i] != '') {
            marketingBlockImageContentHtml += `
              <div class="visible-xs-block product-items__banner-image-content__entry">
                ${collectionMarketingBlocks.text_mobile[i]}
              </div>`;
            marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace(
              '<div class="product-items__banner-image-content__entry"',
              '<div class="hidden-xs product-items__banner-image-content__entry"'
            );
          }
        }

        marketingBlockImageContentHtml += `</div>`;
      }

      if (
        collectionMarketingBlocks.show_on_mobile == null ||
        (collectionMarketingBlocks.show_on_mobile != null && collectionMarketingBlocks.show_on_mobile[i] != 'true')
      ) {
        marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace('class="', 'class="hidden-xs ');
      }

      if (collectionMarketingBlocks.flip_imagetext != null && collectionMarketingBlocks.flip_imagetext[i] == 'true') {
        marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace('class="', 'class="product-items__banner-image-content--reverse ');
      }

      if (collectionMarketingBlocks.left_align_vertical_banner != null && collectionMarketingBlocks.left_align_vertical_banner[i] == 'true') {
        marketingBlockImageContentHtml = marketingBlockImageContentHtml.replace(
          'product-items__banner-image-content',
          'product-items__banner-image-content product-items__banner-image-content--align-left'
        );
      }

      marketingBlockImageContentHtml += '</div>';

      if (marketingBlockImageContentHtml != '<div class="product-items__banner-image-content">') {
        marketingBlocks.push({
          position: parseInt(collectionMarketingBlocks.order[i]),
          html: marketingBlockImageContentHtml,
        });
      }
    }
  }
}
/**
 * Build collection marketing blocks - END
 */

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index, totalProduct) {
  var productCount = totalProduct;
  /*** Prepare data ***/
  var images = data.images_info;
  // data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function (e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  // Product Id
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

  // Product Images
  var imageEl;
  if (images.length > 0) {
    imageEl = '<img src="' + images[0]['src'] + '" alt="{{itemTitle}}" class="cProductCard-image">';

    // If more than one image, add on a secondary image which appears on hover
    if (images.length > 1) {
      imageEl += '<img src="' + images[1]['src'] + '" alt="{{itemTitle}}" class="cProductCard-image cProductCard-image--hover">';
    }
  } else {
    imageEl = bcSfFilterConfig.general.no_image_url;
  }

  itemHtml = itemHtml.replace(/{{imageEl}}/g, imageEl);



  // Add Title Classes
  var itemTitleClasses = [];
  itemTitleClasses.push('tagline_space');
  itemTitleClasses.push('noSubtitle');
  if (data.tags.includes('subtitle')) itemTitleClasses.push('subtitle');
  if (data.tags.includes('beauty')) itemTitleClasses.push('beauty');
  var titleClasses = itemTitleClasses.join(' ');
  itemHtml = itemHtml.replace(/{{itemTitleClasses}}/g, titleClasses);

  // Add Item on Sale cart property
  var onSaleCartAttribute = '';
  if (data.tags.includes('#final-sale')) {
    onSaleCartAttribute = `<input type="hidden" id="status-${data.id}" name="properties[Note]" value="This item is Final Sale">`
  }

  itemHtml = itemHtml.replace(/{{itemOnSaleAttribute}}/g, onSaleCartAttribute);

  // Add Price
  itemHtml = itemHtml.replace('{{itemPrice}}', buildPrice(data));
  // Add color section
  var productColorCount;
  var productColors = [];
  data.options_with_values.forEach(function (cur) {
    if (cur.name == 'color') {
      productColorCount = cur.values.length;
      productColors.push(cur.values);
    }
  });

  var moreColorsHtml;
  if (productColorCount > 1) {
    // Build color swatch section
    var productColorsHtml = '';
    productColors.forEach(function (cur, i) {
      cur.forEach(function (currentColor, index) {
        productColorsHtml +=
          '<a href="{{itemUrl}}">' +
          '<div class="cProductCard-color ' +
          currentColor.title.toLowerCase().replace(' / ', '-').replace(/\ /g, '-').replace('/', '-') +
          '" data="' +
          currentColor.title.toLowerCase().replace(' / ', '-').replace(/\ /g, '-').replace('/', '-') +
          '">' +
          '</div>' +
          '</a>';
      });
    });

    // Build final HTML
    moreColorsHtml = '<div class="cProductCard-pluscolor">' + '+ colors' + '</div>' + '<div class="cProductCard-colors">' + productColorsHtml + '</div>';
  } else {
    moreColorsHtml = '';
  }

  // Replace color placeholder
  itemHtml = itemHtml.replace(/{{moreColorsHtml}}/g, moreColorsHtml);

  // Custom
  // Add data json
  var self = this;
  var itemJson = {
    id: data.id,
    title: data.title,
    handle: data.handle,
    vendor: data.vendor,
    variants: data.variants,
    url: self.buildProductItemUrl(data),
    options_with_values: data.options_with_values,
    images: data.images,
    available: data.available,
    price_min: data.price_min,
    price_max: data.price_max,
    tags: data.tags,
    compare_at_price_min: data.compare_at_price_min,
    compare_at_price_max: data.compare_at_price_max,
  };
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

  // Tag/Badge
  var tagHtml = '';
  var priceText = '';
  var tagSubtitle = Shopify.subtitle;
  var tagPriceTex = 'price#';
  var currentProduct = '';

  for (var i = 0; i < data.tags.length; i++) {
    var _tag = data.tags[i];

    if (_tag.indexOf(tagSubtitle) !== -1) {
      var _tagText = _tag.replace(tagSubtitle, '').trim();

      tagHtml = '<span class="product-item__subtitle">' + _tagText + '</span>';

      break;
    }
  }

  for (var i = 0; i < data.tags.length; i++) {
    var _tag = data.tags[i];
    if (_tag.indexOf(tagPriceTex) !== -1) {
      var tagPriceColor = _tag.split('#')[1].split(':')[0];
      var tagPriceText = _tag.split(':')[1];

      if (currentProduct && currentProduct != '') {
        currentProduct.metafields.badge_background_color = '#2d2d2d';
        currentProduct.metafields.badge_text_color = '#fff';
        var priceText = `<h6 class="cProductCard-tagline product-item__tagline" data-attr-2for="true" style="background-color: ${currentProduct.metafields.badge_background_color}; color: ${currentProduct.metafields.badge_text_color};">${tagPriceText.trim()}</h6>`;
      } else {
        var priceText = `<h6 class="cProductCard-tagline product-item__tagline" data-attr-2for="true">${tagPriceText.trim()}</h6>`;
      }

      //var priceText = '<span class="product-item__price price__amount-text" style="color: #' + tagPriceColor + '">2 FOR THIS' + tagPriceText + '</span>';
    }
  }
  if (priceText.length){
    // show the "2 For $XX" as a tag rather than below the price
    // itemHtml = itemHtml.replace(/{{itemPriceTagText}}/g, priceText);
    itemHtml = itemHtml.replace(/{{itemTag}}/g, priceText);
  }
  itemHtml = itemHtml.replace(/{{itemTag}}/g, tagHtml);

  // Product Item Select
  var selectHtml = '';
  var option = '';
  var selectVariants = data.variants;
  var priceHtml = '';

  for (var selectVariant = 0; selectVariant < selectVariants.length; selectVariant++) {
    var disabledOption = '';
    var selectedOption = '';
    var selectVariantCurrent = selectVariants[selectVariant];
    var selectVariantCompared = selectVariantCurrent.compare_at_price;
    var selectVariantPrice = selectVariantCurrent.price;
    var priceHtml = '';
    var preorderOption = '';

    if (selectVariantCurrent.available && selectVariantCurrent.inventory_quantity < 1) {
      preorderOption = 'data-preorder';
    }

    if (selectVariantCompared > selectVariantPrice) {
      priceHtml = `<del class="price__amount"><span class="money">${bcsffilter.formatMoney(selectVariantCompared)}</span></del>
        <br>
        <ins class="price__amount"><span class="money">${bcsffilter.formatMoney(selectVariantPrice)}</span></ins>`
    } else {
      priceHtml = '<span class="price__amount"><span class="money">' + bcsffilter.formatMoney(selectVariantPrice) + '</span></span>';
    }

    priceHtml = priceHtml.replace('$', '&#36;').replace(/"/g, "'");

    if (!selectVariantCurrent.available) {
      disabledOption = 'disabled';
    }

    if (selectVariant == 0) {
      selectedOption = 'selected';
    }

    var option2 = '';
    if (typeof selectVariantCurrent.options[1] != 'undefined') {
      option2 = selectVariantCurrent.options[1];
    }
    var option3 = '';
    if (typeof selectVariantCurrent.options[2] != 'undefined') {
      option3 = selectVariantCurrent.options[2];
    }

    option = `${option}
    <option value="${selectVariantCurrent.id}" data-price="${priceHtml}" data-option-1="${selectVariantCurrent.options[0]}"
      data-option-2="${option2}"  data-option-3="${option3}" ${disabledOption} ${selectedOption} ${preorderOption}>${selectVariantCurrent.title}</option>`
  }

  selectHtml = '<select name="id" class="product-single__variants js-product-item-select">' + option + '</select>';

  itemHtml = itemHtml.replace(/{{itemSelect}}/g, selectHtml);

  // Color Swatches
  var variantsHtml = '';
  var variantsSizeHtml = '';
  var optionValues = data.options_with_values;
  var currentUrl = window.location.search.replace('%20', '-');
  var colorHandle = 'color';
  var options = '';
  var radioOptionHtml = '';
  var radioSizeHtml = '';
  var idxColor = '';
  var idxSize = '';
  var colorsArr = [];
  var variantImagesHtml = '';
  var colorsNewArr = [];
  var colorNumber = 0;
  var colorNumberVariant = '';
  var otherOptions = '';
  var otherOptionName = '';

  if (currentUrl.indexOf('pf_opt_color=') !== -1) {
    const colorArr = currentUrl.split('pf_opt_color=');
    colorArr.shift();

    for (var i = 0; i < colorArr.length; i++) {
      var colorArrItem = colorArr[i];
      var colorOnly = colorArrItem;

      if (colorArrItem.indexOf('&pf') !== -1) {
        colorOnly = colorArrItem.split('&pf')[0];
      }

      colorsArr.push(colorOnly);
    }
  }

  for (var i = 0; i < optionValues.length; i++) {
    var optionHandle = handleize(optionValues[i].name);

    if (optionHandle == colorHandle) {
      options = optionValues[i].values;
      idxColor = i;
    } else {
      otherOptionName = optionValues[i].name;
      otherOptions = optionValues[i].values;
      idxSize = i;
    }

    if (i == 2) {
      break;
    }
  }

  if (otherOptions != '') {
    var optionSizeIdx = idxSize + 1;

    for (var i = 0; i < otherOptions.length; i++) {
      var variantSizeTitle = otherOptions[i].title;
      var variantSizeTitleHandle = handleize(variantSizeTitle);
      var radioSizeId = 'radios-collection-size-' + variantSizeTitleHandle + '-' + index + '-' + i;

      radioSizeHtml += `<li>
        <div class="radio-size js-radio-size-item">
          <input type="radio" name="radios-collection-size-${index}" id="${radioSizeId}" value="${variantSizeTitleHandle}" data-option="${optionSizeIdx}" data-value="${variantSizeTitle}" data-index="${i}">
          <label for="${radioSizeId}">${variantSizeTitle}</label>
        </div>
      </li>`
    }
  }

  if (options != '') {
    var optionIdx = idxColor + 1;
    var filteredFlag = true;

    for (var i = 0; i < options.length; i++) {
      var variantTitle = options[i].title;
      var variantTitleHandle = handleize(variantTitle);
      var checkedHtml = '';
      var filteredClass = '';
      var radioColorId = 'radios-collection-' + variantTitleHandle + '-' + index + '-' + i;
      colorNumber = colorNumber + 1;
      colorNumberVariant = variantTitle;

      if (i == 0) {
        checkedHtml = 'checked';
      }

      if (colorsArr != '' && filteredFlag) {
        for (var x = 0; x < colorsArr.length; x++) {
          var colorValue = colorsArr[x];
          var colorValueHandle = handleize(colorValue);

          if (colorValueHandle == variantTitleHandle) {
            filteredClass = ' class="js-radio-filtered"';
            filteredFlag = false;
          }
        }
      }

      radioOptionHtml +=
        '<li><div class="radio-color js-radio-color-item"><input type="radio" name="radios-collection-' +
        index +
        '" id="' +
        radioColorId +
        '" value="' +
        variantTitleHandle +
        '" data-option="' +
        optionIdx +
        '" data-value="' +
        variantTitle +
        '" data-index="' +
        i +
        '" ' +
        checkedHtml +
        ' data-image-target="' +
        data.handle +
        '-' +
        index +
        '"' +
        filteredClass +
        '><label for="' +
        radioColorId +
        '"' +
        ' class="' +
        variantTitleHandle +
        '"></label></div></li>';
    }

    if (data.images.length > 1) {
      variantImagesHtml +=
        `<figure class="expanded-hover">
          <a href="/products/${data.handle}"></a>
          <img src="${getGridSize(data.images[1].src)}" srcset="${getGridSize(data.images[1].src)} 200w,
          ${getGridSize(data.images[1].src)} 500w,
          ${getGridSize(data.images[1].src)} 700w,
          ${getGridSize(data.images[1].src)} 1000w" />
        </figure>`
    } else if (data.images.length == 1) {
      variantImagesHtml +=
        `<figure class="expanded-hover">
          <a href="/products/${data.handle}"></a>
          <img src="${getGridSize(data.featured_image.src)}" srcset="${getGridSize(data.featured_image.src)} 200w,
            ${getGridSize(data.featured_image.src)} 500w,
            ${getGridSize(data.featured_image.src)} 700w,
            ${getGridSize(data.featured_image.src)} 1000w"/>
        </figure>`
    }

    for (var i = 0; i < data.variants.length; i++) {
      var optionColor = data.variants[i].options[idxColor];
      var classExpanded = '';
      var importanceLowAttr = '';
      var variantImageHtml = '';
      var emptyVariantImage = '';

      if (colorsNewArr.indexOf(optionColor) === -1) {
        colorsNewArr.push(optionColor);

        if (i == 0) {
          classExpanded = 'expanded';
        }

        if (i > 0) {
          importanceLowAttr = 'importance="low"';
        }

        if (data.variants[i].image != null) {
          variantImageHtml = `<img src="${data.variants[i].image}" class="responsive-image" loading="lazy"/>`
        } else if (data.images.length > 0) {
          variantImageHtml = `<img src="${data.featured_image.src}" class="responsive-image" loading="lazy"/>`
        } else {
          emptyVariantImage = ' no-image';
        }

        variantImagesHtml += `<figure
          class="${classExpanded} ${emptyVariantImage}"
          data-variant-image="${data.handle}-${i}"
          data-target-index="${colorsNewArr.length}"
        >
          <a href="/products/${data.handle}?variant=${data.variants[i].id}"></a>
          ${variantImageHtml}
        </figure>`
      }
    }

  } else {
    if (data.images.length > 1) {
      variantImagesHtml = `<figure class="hover-alt">
          <a href="/products/${data.handle}"></a>
          <img src="${getGridSize(data.featured_image.src)}" srcset="${getGridSize(data.featured_image.src)} 200w,
          ${getGridSize(data.featured_image.src)} 500w,
          ${getGridSize(data.featured_image.src)} 700w,
          ${getGridSize(data.featured_image.src)} 1000w"/>
        </figure><figure class="hover-alt">
          <a href="/products/${data.handle}"></a>
          <img src="${getGridSize(data.images[1].src)}" srcset="${getGridSize(data.images[1].src)} 200w,
          ${getGridSize(data.images[1].src)} 500w,
          ${getGridSize(data.images[1].src)} 700w,
          ${getGridSize(data.images[1].src)} 1000w"/>
        </figure>`
    } else if (data.images.length == 1) {
      variantImagesHtml =
        `<figure class="expanded">
          <a href="/products/${data.handle}"></a>
          <img src="${getGridSize(data.featured_image.src)}" srcset="${getGridSize(data.featured_image.src)} 200w,
          ${getGridSize(data.featured_image.src)} 500w,
          ${getGridSize(data.featured_image.src)} 700w,
          ${getGridSize(data.featured_image.src)} 1000w"/>
        </figure>`
    } else {
      variantImagesHtml = '<figure class="no-image"><a href="/products/' + data.handle + '"></a></figure>';
    }
  }

  if (radioSizeHtml != '' && radioOptionHtml != '') {
    var optionSizeTitle = '';
    if (otherOptionName != '' && Shopify.selectOption.indexOf('{{ name }}') !== -1) {
      optionSizeTitle = '<span>' + Shopify.selectOption.replace('{{ name }}', otherOptionName) + '</span>';
    }

    variantsSizeHtml =
      `<div class="product-item__actions">
        <button type="submit" class="product-item__btn js-product-item-btn button ready_to_add" name="add">${Shopify.buttonText}</button>
      </div>
      <div class="product-item__sizes">
        ${optionSizeTitle}
        <p class="hide-element">
          <small>${Shopify.soldOut}</small>
          <a href="${self.buildProductItemUrl(data)}">${Shopify.soldOutLink}</a>
        </p>
        <ul class="list-radios-sizes js-radios-sizes">${radioSizeHtml}</ul>
      </div>`
  } else {
    var additionalClass = '';

    if (data.variants.length === 1 && !data.variants[0].available) {
      additionalClass = 'js-product-item-btn-popup';
    }

    var text = additionalClass !== ''
        ? Shopify.soldOut
        : Shopify.buttonTextAdd;

    variantsSizeHtml = `<div class="product-item__actions"><button type="submit" class="product-item__btn js-product-item-btn ${additionalClass} button ready_to_add" name="add">${text}</button></div>`
  }

  if (radioOptionHtml != '') {
    var colorNumberHtml = '';

    if (colorNumber == 1) {
      colorNumberHtml = `<span class="product-item__mobile">${colorNumberVariant}</span><span class="product-item__desktop">${colorNumber} ${Shopify.colorText }</span>`
    } else if (colorNumber > 1) {
      colorNumberHtml = `<span>${colorNumber} ${Shopify.colorsText}</span>`;
    }

    variantsHtml =
      '<div class="product-item__variants">' + colorNumberHtml + '<ul class="list-radios-colors js-radios-colors">' + radioOptionHtml + '</ul></div>';
  }

  itemHtml = itemHtml.replace(/{{variantsHtml}}/g, variantsHtml);
  itemHtml = itemHtml.replace(/{{variantsSizeHtml}}/g, variantsSizeHtml);
  itemHtml = itemHtml.replace(/{{variantImagesHtml}}/g, variantImagesHtml);

  // Wishlist
  var itemWishlistHtml = "<!-- include 'wishlist-button-collection' with '" + data.id + "' -->";
  itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

  var titleText = data.title;

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add onSale class
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

  // Add soldOut Label
  var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

  // Add onSale Label
  var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

  // Add Vendor
  var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, titleText);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, '/products/' + data.handle);

  if (data.tags.includes('hide_from_front_end')) {
    itemHtml = '';
  }

  if (bcsffilter.queryParams.page === 1) {
    if (!isSearch) {
      marketingBlocks.forEach((block) => {
        if (block.position == index && block.position == 1) {
          itemHtml = block.html + itemHtml;
        } else if (block.position == index && block.position != 1 && bcsffilter.hasFilterOptionParam === false) {
          itemHtml = itemHtml + block.html;
        }
      });
    }
  }

  if (itemHtml.indexOf('vertical') != -1) {
    hasVerticalBlock = true;
  }

  return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
  // // Add Description
  // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  // // Truncate by word
  // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
  // // Truncate by character
  // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
  // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
  if (this.getSettingValue('general.paginationType') == 'default') {
    // Get page info
    const currentPageValue = this.queryParams.page || window.COLLECTION.current_page
    const limit = this.queryParams.limit || window.COLLECTION.products_per_page

    if (!currentPageValue) {
      location.reload()
    }

    var currentPage = parseInt(currentPageValue);
    var totalPage = Math.ceil(totalProduct / limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
      jQ(this.selector.bottomPagination).html('');
      return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
      var paginationHtml = bcSfFilterTemplate.paginateHtml;

      // Build Previous
      var previousHtml = currentPage > 1 ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = currentPage < totalPage ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += pageArr[iPage] == currentPage ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

      jQ(this.selector.bottomPagination).html(paginationHtml);
    }
  }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    $(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '<option selected value="manual">Featured</option>';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      $(this.selector.topSorting).html(html);

      // Set current value
      $(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }

  var selectedOption = $('.collection-sort__input').val();
  var optionLength = $('.collection-sort__input').find(`option[value="${selectedOption}"]`).text().length;
  var parentAvailableSize = $('#bc-sf-filter-top-sorting').width() - $('#bc-sf-filter-top-sorting label').outerWidth(true);


  if (selectedOption) {
    if(selectedOption.includes('manual')) {
      optionLength = optionLength / 2;
    }
    if(selectedOption.includes('created-descending')) {
      optionLength = 12;
    }
  }

  if (parentAvailableSize < optionLength * 9.5) {
    optionLength = parentAvailableSize;
  } else {
    optionLength = optionLength * 9.5;
  }

  $('.collection-sort__input').css('width', `${optionLength}px`);
};

// Build Default layout
function buildDefaultLink(a, b) {
  var c = window.location.href.split("?")[0]; return c += "?" + a + "=" + b } BCSfFilter.prototype.buildDefaultElements = function (a) {
    if (bcSfFilterConfig.general.hasOwnProperty("collection_count") && jQ("#bc-sf-filter-bottom-pagination").length > 0) { var b = bcSfFilterConfig.general.collection_count, c = parseInt(this.queryParams.page), d = Math.ceil(b / (this.queryParams.limit || window.COLLECTION.products_per_page)); if (1 == d) return jQ(this.selector.pagination).html(""), !1; if ("default" == this.getSettingValue("general.paginationType")) { var e = bcSfFilterTemplate.paginateHtml, f = ""; f = c > 1 ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml") ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml") ? bcSfFilterTemplate.previousDisabledHtml : "", f = f.replace(/{{itemUrl}}/g, buildDefaultLink("page", c - 1)), e = e.replace(/{{previous}}/g, f); var g = ""; g = c < d ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml") ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml") ? bcSfFilterTemplate.nextDisabledHtml : "", g = g.replace(/{{itemUrl}}/g, buildDefaultLink("page", c + 1)), e = e.replace(/{{next}}/g, g); for (var h = [], i = c - 1; i > c - 3 && i > 0; i--)h.unshift(i); c - 4 > 0 && h.unshift("..."), c - 4 >= 0 && h.unshift(1), h.push(c); for (var j = [], k = c + 1; k < c + 3 && k <= d; k++)j.push(k); c + 3 < d && j.push("..."), c + 3 <= d && j.push(d); for (var l = "", m = h.concat(j), n = 0; n < m.length; n++)"..." == m[n] ? l += bcSfFilterTemplate.pageItemRemainHtml : l += m[n] == c ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, l = l.replace(/{{itemTitle}}/g, m[n]), l = l.replace(/{{itemUrl}}/g, buildDefaultLink("page", m[n])); e = e.replace(/{{pageItems}}/g, l), jQ(this.selector.pagination).html(e) } } if (bcSfFilterTemplate.hasOwnProperty("sortingHtml") && jQ(this.selector.topSorting).length > 0) { jQ(this.selector.topSorting).html(""); var o = this.getSortingList(); if (o) { var p = ""; for (var q in o) p += '<option value="' + q + '">' + o[q] + "</option>"; var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p); jQ(this.selector.topSorting).html(r); var s = void 0 !== this.queryParams.sort_by ? this.queryParams.sort_by : this.defaultSorting; jQ(this.selector.topSorting + " select").val(s), jQ(this.selector.topSorting + " select").change(function (a) { window.location.href = buildDefaultLink("sort_by", jQ(this).val()) }) } } };

function customizeJsonProductData(data) { for (var i = 0; i < data.variants.length; i++) { var variant = data.variants[i]; var featureImage = data.images.filter(function (e) { return e.src == variant.image; }); if (featureImage.length > 0) { variant.featured_image = { "id": featureImage[0]['id'], "product_id": data.id, "position": featureImage[0]['position'], "created_at": "", "updated_at": "", "alt": null, "width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id] } } else { variant.featured_image = ''; }; }; var self = bcsffilter; var itemJson = { "id": data.id, "title": data.title, "handle": data.handle, "vendor": data.vendor, "variants": data.variants, "url": self.buildProductItemUrl(data), "options_with_values": data.options_with_values, "images": data.images, "images_info": data.images_info, "available": data.available, "price_min": data.price_min, "price_max": data.price_max, "compare_at_price_min": data.compare_at_price_min, "compare_at_price_max": data.compare_at_price_max }; return itemJson; };
BCSfFilter.prototype.prepareProductData = function (data) {
  var self = this; var countData = data.length; for (var k = 0; k < countData; k++) { data[k]["images"] = data[k]["images_info"]; if (data[k]["images"].length > 0) {
    data[k]["featured_image"] = data[k]["images"][0] } else { data[k]["featured_image"] = { src: bcSfFilterConfig.general.no_image_url, width: "", height: "", aspect_ratio: 0 } }
    data[k]["url"] = "/products/" + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]["options_with_values"].length;
    for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]["options_with_values"][i]["name"]) } data[k]["options"] = optionsArr; var firstVariant = data[k]["variants"][0];
    var isRoundedPrice = true; if (firstVariant.hasOwnProperty("fulfillment_service") && firstVariant.fulfillment_service == "gift_card") { isRoundedPrice = false } if (typeof self.convertPriceBasedOnActiveCurrency !== "undefined") {
      data[k].price_min = self.convertPriceBasedOnActiveCurrency(data[k].price_min, isRoundedPrice); data[k].price_max = self.convertPriceBasedOnActiveCurrency(data[k].price_max, isRoundedPrice);
      data[k].compare_at_price_min = self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min, isRoundedPrice); data[k].compare_at_price_max = self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max, isRoundedPrice) }
      data[k]["price_min"] *= 100, data[k]["price_max"] *= 100; if (data[k]["compare_at_price_min"] != null) { data[k]["compare_at_price_min"] *= 100 } if (data[k]["compare_at_price_max"] != null) { data[k]["compare_at_price_max"] *= 100 } data[k]["price"] = data[k]["price_min"]; data[k]["compare_at_price"] = data[k]["compare_at_price_min"]; data[k]["price_varies"] = data[k]["price_min"] != data[k]["price_max"]; if (getParam("variant") !== null && getParam("variant") != "") { var paramVariant = data[k]["variants"].filter(function (e) { return e.id == getParam("variant") }); if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0] } else { var countVariants = data[k]["variants"].length; for (var i = 0; i < countVariants; i++) { if (data[k]["variants"][i].available) { firstVariant = data[k]["variants"][i]; break } } } data[k]["selected_or_first_available_variant"] = firstVariant; var countVariants = data[k]["variants"].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]["variants"][i]; var variantOptions = variant["merged_options"]; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(":"); data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1]; data[k]["variants"][i]["option_" + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]["variants"][i]["options"] = variantOptionArr } if (data[k]["variants"][i]["compare_at_price"] != null) { var variantCompareAtPrice = parseFloat(data[k]["variants"][i]["compare_at_price"]); if (typeof self.convertPriceBasedOnActiveCurrency !== "undefined") { variantCompareAtPrice = self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice, isRoundedPrice) } data[k]["variants"][i]["compare_at_price"] = variantCompareAtPrice * 100 } var variantPrice = parseFloat(data[k]["variants"][i]["price"]); if (typeof self.convertPriceBasedOnActiveCurrency !== "undefined") { variantPrice = self.convertPriceBasedOnActiveCurrency(variantPrice, isRoundedPrice) } data[k]["variants"][i]["price"] = variantPrice * 100 } data[k]["description"] = data[k]["content"] = data[k]["body_html"]; if (data[k].hasOwnProperty("original_tags") && data[k]["original_tags"].length > 0) { data[k]["tags"] = data[k]["original_tags"].slice(0) } data[k]["json"] = customizeJsonProductData(data[k]) } return data };

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
  var isCollectionFiltered = document.querySelector('#shopify-section-collection-filtered');

  if (isCollectionFiltered !== null) {
    // Add header before the first product
    var header = document.querySelector('.jsCollectionHeader h1');
    if (header !== null) {
      var headerTitle = document.querySelector('.jsCollectionHeader h1').innerHTML;
      var headerImageUrl = document.querySelector('.jsCollectionHeader .sCollection-header-image').style.backgroundImage.slice(4, -1).replace(/"/g, '');

      var headerHtml =
        `<div class="cProductCard sCollection-filtered-header-container">
          <div class="sCollection-header jsCollectionHeader jsCollectionFilterHeader">
            <div class="sCollection-header-image" style="background-image: url(${headerImageUrl})">
              <h2 class="sCollection-title">${headerTitle}</h2>
            </div>
          </div>
        </div>`

      document.querySelector('#bc-sf-filter-products').insertAdjacentHTML('afterbegin', headerHtml);
      document.querySelector('.jsCollectionFilterHeader').style.width = '100%';
    }
  }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
  // Fetch metafields and create metafield-dependent elements
  // Have to page by 20 products due to Shopify's all_products limit
  // Calls search.filter-metafields.liquid to retreive and format the json data

  $('.bc-sf-filter-total-product').text(data.total_product);

  var collectionTagline = '';

  if (Shopify.collection != undefined) {
    collectionTagline = Shopify.collection.metafields.tagline;
  }

  for (var start = 0; start < data.total_product; start += 20) {
    var fetch_products = data.products.slice(start, start + 20);
    var fetch_handles = fetch_products.map((product) => product.handle).join('|');
    $.getJSON(`/search?q=${fetch_handles}&view=filter-metafields`, function (data) {
      data.products.forEach((product) => {
        var $productItemEl = $('.js-product-item');
        let titleEl;
        let productPrice;
        let tagContainer;

        if ($productItemEl.length) {
          titleEl = $(`.js-product-item[data-product-id="${product.id}"] .product-item__line`);
          tagContainer = $(`.js-product-item[data-product-id="${product.id}"] .product__item__banner__tag`);
          productPrice = $(`.js-product-item[data-product-id="${product.id}"] .product-item__price-holder`);
        } else {
          titleEl = $(`.cProductCard[data-product-id="${product.id}"] .cProductCard-title`);
          tagContainer = $(`.cProductCard[data-product-id="${product.id}"] .product__item__banner__tag`);
        }

        product.metafields.badge_background_color = '#2d2d2d';
        product.metafields.badge_text_color = '#fff';

        if (collectionTagline != '') {
          let taglineEl = $(`<h6 class="cProductCard-tagline product-item__tagline">${collectionTagline}</h6>`);
          //taglineEl.insertBefore(titleEl);
          tagContainer.html(taglineEl);
          titleEl.removeClass('tagline_space');
        } else if (product.metafields.tagline) {
          let taglineEl = $(`<h6 class="cProductCard-tagline product-item__tagline">${product.metafields.tagline}</h6>`);
          //taglineEl.insertBefore(titleEl);
          titleEl.removeClass('tagline_space');
          tagContainer.html(taglineEl);
        } else {
          // show the "2 For $XX" as a tag rather than below the price
          let taglineEl = $(tagContainer).find('h6');
          if (taglineEl.length){
            if (taglineEl.attr('data-attr-2for')=='true'){
              tagContainer.show();
            } else {
              tagContainer.hide();
            }
          } else {
            tagContainer.hide();
          }
        }

        if (product.metafields.subtitle_collection) {
          let subtitleCollectionEl = $(`<span class="product-item__subtitle">${product.metafields.subtitle_collection}</span>`);
          subtitleCollectionEl.insertAfter(titleEl);
          titleEl.removeClass('noSubtitle');
        }

        if (product.metafields.subtitle) {
          let subtitleEl = $(`<div class="product-item__subtitle">${product.metafields.subtitle}</div>`);
          subtitleEl.insertBefore(productPrice);
          titleEl.removeClass('noSubtitle');
        }

        if ($productItemEl.length && product.metafields.shipping_date) {
          $('.js-product-item[data-product-id="' + product.id + '"] input[data-prop-date]').attr('data-prop-date', product.metafields.shipping_date);
        }
      });
    });
  }

  // Marketing blocks
  $('.product-items__banner--vertical').prev().addClass('clear');

  if (hasVerticalBlock) {
    $('.product-items').addClass('product-items--block');

    // const $titles = $('.product-item__title a');

    // $titles.each(function(index, el) {
    //   const title = $(this).text();

    //   if (title.length > 15) {
    //     const truncateTitle = $.trim(title).substring(0, 15).split(' ').slice(0, -1).join(' ') + '...';

    //     $(this).text(truncateTitle);
    //   }
    // });
  }

  // Hide certain elements if no filter applies
  var filterOptions = document.querySelector('#bc-sf-filter-tree .bc-sf-filter-option-block');

  if (filterOptions == null) {
    // Hide filter title if there are no filter options, only the sorting dropdown
    if (document.querySelector('.filter__action-bar')) {
      document.querySelector('.filter__action-bar').style.display = 'none';
    }
  }

  // Sort by dropdown
  var sortingLabel = document.querySelector('#bc-sf-filter-top-sorting .label--hidden');

  if (sortingLabel) {
    // Rename options
    document.querySelector('option[value="best-selling"]').textContent = 'Best Sellers';
    document.querySelector('option[value="created-descending"]').textContent = 'New Arrivals';
  }

  for (key in bcsffilter.queryParams) {
    if (/^pf_?/.test(key)) {
      document.querySelector('.btn-clear-filter').classList.add('visible');
    }
  }

  // Load products
  var productCardList = document.querySelectorAll('.cProductCard');
  productCardList.forEach(function (pCard) {
    pCard.classList.add('cProductCard-loaded');
  });

  // Hide/Show the Clear Filters button based on whether filter active
  var optionsSelected = document.querySelectorAll('a.bc-sf-filter-option-item.bc-sf-filter-option-label.selected').length > 0;
  if (optionsSelected) {
    var elems = document.querySelectorAll('.btn-clear-filter');
    [].forEach.call(elems, function (el) {
      el.classList.add('visible');
    });
  } else {
    var elems = document.querySelectorAll('.btn-clear-filter');
    [].forEach.call(elems, function (el) {
      el.classList.remove('visible');
    });
  }

  // Click Products
  var $checkedInput = jQ('.js-radio-color-item input:checked');
  if ($checkedInput.length) {
    $checkedInput.each(function () {
      $(this).trigger('change');
    });
  }

  var $filteredInput = jQ('.js-radio-color-item input.js-radio-filtered');
  if ($filteredInput.length) {
    $filteredInput.trigger('click');
  }
};

function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace('_', '-');
}

function imageSizes() {
  const sizes = $('.js-product-image-sizes').val();

  return sizes;
}

function getGridSize(src, size = 720) {
  return src.replace('.jpg', `_${size}x.jpg`)
  return src;
}

function imageLarge(src) {
  let imageSrc = src;
  let sizes = imageSizes().split(',');
  let lastMediaQuery = sizes[sizes.length - 1];
  let windowWidth = window.innerWidth;
  let imageSizeString = '';

  for (let index = 0; index < sizes.length; index++) {
    let mediaQuery = sizes[index];

    if (windowWidth >= lastMediaQuery) {
      imageSizeString = '_' + lastMediaQuery + 'x.';
      break;
    }

    if (windowWidth <= mediaQuery) {
      imageSizeString = '_' + mediaQuery + 'x.';
      break;
    }
  }

  if (imageSrc.indexOf('_large.') !== -1) {
    imageSrc = imageSrc.replace('_large.', imageSizeString);
  }

  return imageSrc;
}

function buildPrice(data) {
  var html = '';
  html = '';
  // if (data.compare_at_price_min > data.price_min) {
  //   html += '<del class="price__amount"><span class="money">' + bcsffilter.formatMoney(data.compare_at_price_min) + '</span></del> ';
  //   html += '<ins class="price__amount"><span class="money">' + bcsffilter.formatMoney(data.price_min) + '</span></ins>';}
  if (data.price_max > data.price_min) {

    html += '<span class="price__amount"><span class="money">' + bcsffilter.formatMoney(data.price_min) + ' - ' + bcsffilter.formatMoney(data.price_max) + '</span></span>';
  } else {
    if (priceVaries) {
      html += bcSfFilterConfig.label_basic.from + ' ';
    }
    if(data.compare_at_price_min > data.price_min){
      html += '<del class="price__amount"><span class="money">' + bcsffilter.formatMoney(data.compare_at_price_min) + '</span></del><br>';
      html += '<ins class="price__amount"><span class="money">' + bcsffilter.formatMoney(data.price_min) + '</span></ins>';
    }else{
      html += '<span class="price__amount"><span class="money">' + bcsffilter.formatMoney(data.price_min) + '</span></span>';
    }

  }
  html += '';
  if (bcSfFilterConfig.custom.show_price) {
  }
  return html;
}

function onInteractWithFilterOptionValue(a, b, c, d, e, f) {
  var g = bcsffilter,
    h = jQ(b).data('count'),
    f = void 0 !== f && 'true' === f;
  if (g.isMobile() && 'style2' == g.mobileStyle)
    a.preventDefault(),
      (h > 0 || (!0 === f && 'collection' == c)) &&
      ((g.internalClick = !0),
        'single' == e && jQ('.bc-sf-filter-option-block-active').find('ul li').children().removeClass('selected'),
        jQ(b).toggleClass('selected'),
        jQ(b).siblings().toggleClass('selected'),
        g.buildFilterSelectionMobile());
  else if (!1 === f && 'sub_category' != d && (a.preventDefault(), h > 0 || void 0 == h)) {
    g.internalClick = !0;
    var i = jQ(b).attr('data-id'),
      j = decodeURIComponent(jQ(b).attr('data-value'));
    'collection' == c && (g.queryParams.collection_scope = g.collectionId = jQ(b).data('collection-scope'));
    var k = ('list' != d && 'sub_category' != d) || 'single' != e ? g.buildFilterOptionLink(i, j, c, d, e) : jQ(b).attr('href');
    g.onChangeData(k, c, j, i);
  }
  if (ga) {
    var filterList = [];
    if (g.queryParams) {
      if (g.queryParams.pf_t_color) filterList.push(g.queryParams.pf_t_color);
      if (g.queryParams.pf_t_perfect_for) filterList.push(g.queryParams.pf_t_perfect_for);
      if (g.queryParams.pf_t_trimester) filterList.push(g.queryParams.pf_t_trimester);
      if (g.queryParams.pf_t_type) filterList.push(g.queryParams.pf_t_type);
    }
    if (filterList.length) {
      filterList.join(', ');
      ga('send', 'event', 'Collection', 'filter', 'Collection ID ' + g.collectionId + ': ' + filterList);
    }
  }
}

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
  var self = bcsffilter;
  var ext = typeof ext !== 'undefined' ? ext : 'png';
  var version = typeof version !== 'undefined' ? version : '1';
  var prIndex = self.fileUrl.lastIndexOf('?');
  if (prIndex > 0) {
    var filePath = self.fileUrl.substring(0, prIndex);
  } else {
    var filePath = self.fileUrl;
  }
  filePath += fileName + '.' + ext + '?v=' + version;
  return filePath;
}

$('.filter').scroll(function(){
  var currentFilterHeight = $('.filter__container__filter-wrapper').height();
  $('.filter__container_open').height(currentFilterHeight);
});


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem = function (html, iLabel, iValue, fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData) { var keepValuesStatic = fOData.hasOwnProperty("keepValuesStatic") ? fOData.keepValuesStatic : false; if (fOType == "review_ratings" && this.getSettingValue("general.ratingSelectionStyle") == "text") { var title = this.getReviewRatingsLabel(fOItemValue.from) } else { var title = this.customizeFilterOptionLabel(iLabel, fOData.prefix, fOType) } if (keepValuesStatic === true) var productNumber = null; else var productNumber = fOItemValue.hasOwnProperty("doc_count") ? fOItemValue.doc_count : 0; html = html.replace(/{{itemLabel}}/g, this.buildFilterOptionLabel(iLabel, productNumber, fOData)); html = html.replace(/{{itemLink}}/g, this.buildFilterOptionLink(fOId, iValue, fOType, fODisplayType, fOSelectType, keepValuesStatic)); html = html.replace(/{{itemValue}}/g, encodeURIParamValue(iValue)); html = html.replace(/{{itemTitle}}/g, title); html = html.replace(/{{itemFunc}}/g, "onInteractWithFilterOptionValue(event, this, '" + fOType + "', '" + fODisplayType + "', '" + fOSelectType + "', '" + keepValuesStatic + "')"); html = this.checkFilterOptionSelected(fOId, iValue, fOType, fODisplayType) ? html.replace(/{{itemSelected}}/g, "selected") : html.replace(/{{itemSelected}}/g, ""); var htmlElement = jQ(html); htmlElement.children().attr({ "data-id": fOId, "data-value": encodeURIParamValue(iValue), "data-parent-label": fOLabel, "data-title": title, "data-count": productNumber }); if (fOType != "collection") { htmlElement.children().attr("rel", "nofollow") } if (fOType == "collection") htmlElement.children().attr("data-collection-scope", fOItemValue.key); return jQ(htmlElement)[0].outerHTML };
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter = function () { return this.isBadUrl() ? void (window.location.href = window.location.pathname) : (this.updateApiParams(!1), void this.getFilterData("init")) }, BCSfFilter.prototype.isBadUrl = function () { try { var t = decodeURIComponent(window.location.search).split("&"), e = !1; if (t.length > 0) for (var i = 0; i < t.length; i++) { var n = t[i], a = (n.match(/</g) || []).length, r = (n.match(/>/g) || []).length, o = (n.match(/alert\(/g) || []).length, h = (n.match(/execCommand/g) || []).length; if (a > 0 && r > 0 || a > 1 || r > 1 || o || h) { e = !0; break } } return e } catch (l) { return !0 } };
/* End patch boost-010 run 2 */
